import { apiClient } from './client';

/**
 * "Настройки профиля" — 1:1 старый Orchid UserProfileScreen (см. докблок
 * ProfileController в Laravel). Роль — только для отображения (в самом
 * старом экране её не было, добавлена в новом дизайне), login — тоже только
 * для отображения, в блоке смены пароля (тот же "Единый логин", что был
 * disabled-полем в ProfilePasswordLayout).
 */
export interface Profile {
  name: string;
  lastname: string | null;
  firstname: string | null;
  surname: string | null;
  email: string;
  login: string;
  role: string | null;
}

export async function fetchProfile(): Promise<Profile> {
  const { data } = await apiClient.get<Profile>('/profile');
  return data;
}

export interface UpdateProfilePayload {
  name: string;
  lastname: string | null;
  firstname: string | null;
  surname: string | null;
  email: string;
}

export async function updateProfile(payload: UpdateProfilePayload): Promise<Profile> {
  const { data } = await apiClient.put<Profile>('/profile', payload);
  return data;
}

export interface UpdateProfilePasswordPayload {
  password: string;
  passwordConfirmation: string;
}

/** Реально синкает пароль во внешний SSO (AuthService::password() в Laravel) — увеличенный таймаут. */
export async function updateProfilePassword(
  payload: UpdateProfilePasswordPayload,
): Promise<{ success: boolean }> {
  const { data } = await apiClient.put<{ success: boolean }>('/profile/password', payload, {
    timeout: 35_000,
  });
  return data;
}
